function ExploreMore(params) {
    if(!params.element.length) {
        return;
    }
    
    this.setDefaults(params);
    this.addListeners();
}

ExploreMore.prototype.setDefaults = function(params) {
    this.filters = { topics: [], categories: [] };
    this.filterDisplayClass = params.filterDisplayClass;
    this.labelClass = params.labelClass;
    this.noteClass = params.noteClass;
    this.cardClasses = params.cardClasses;
    this.arrowClass = params.arrowClass;
    
    this.results = [];
    this.pageIndex = 1;
    this.pageSize = params.element.data('page-size') || 10;

    this.api = {
        search: "/api/WorkforcePartnerships/GetResources"
    };
        
    this.dom = {
        $container: params.element,
        $form: params.element.find(params.form),
        $field: params.element.find(params.field),
        $noResultsMessage: params.element.find(params.noResultsMessage),
        $modalTrigger: params.element.find(params.modalTrigger),
        $searchTriggers: params.element.find(params.searchTriggers),
        $filterList: params.element.find(params.filterList),
        $filters: params.element.find(params.filters),
        $searchInfo: params.element.find(params.searchInfo),
        $appliedFilterList: params.element.find(params.appliedFilterList),
        $appliedFilters: params.element.find(params.appliedFilters),
        $pagination: params.element.find(params.pagination),
        $resultsWrapper: params.element.find(params.resultsWrapper)
    };
};

ExploreMore.prototype.addListeners = function() {
    this.dom.$form.on("submit", this.handleSearch.bind(this));
    this.dom.$modalTrigger.on("click", this.toggleModal.bind(this));
    this.dom.$searchTriggers.on("click", this.handleSearch.bind(this));
    this.dom.$filters.on("change", this.updateFilters.bind(this));
    this.dom.$appliedFilters.on("click", "button", this.clearFilters.bind(this));
    this.dom.$pagination.on("click", "button", this.goToPage.bind(this));
};

ExploreMore.prototype.handleSearch = function (e) {
    e.preventDefault();
    this.runSearch(1);
}

ExploreMore.prototype.runSearch = function(pageIndex) {
    var _this = this, 
        input = this.dom.$form.find('input[type=text]');
    
    this.keyword = input.val().trim();
    input.val(this.keyword);

    var params = { 
        Keyword: this.keyword, 
        Topics: this.filters.topics.map(function (item) {
            return item.value;
        }),
        Categories: this.filters.categories.map(function (item) {
            return item.value;
        }),
        PageIndex: pageIndex, 
        PageSize: this.pageSize
    };

    $.post(
        this.api.search, params
    ).done(function(data) {
        _this.results = data.Results;
        _this.resultCount = data.TotalResults;
        _this.pageIndex = data.PageIndex;
        _this.dom.$container.find(".hide").removeClass("hide");
    }).then(function() {
        _this.updateResults();
    });
};

ExploreMore.prototype.goToPage = function(e) {
    var targetPage = $(e.target).data("page-key");
        lastPage = parseInt(
            this.dom.$pagination.find("li:nth-last-child(3) button").data("page-key")
        );

    switch (targetPage) {
        case "first":
            this.pageIndex = 1;
            break;
        case "prev":
            if (this.pageIndex > 1) 
                this.pageIndex--;
            break;
        case "next":
            if (this.pageIndex < lastPage) 
                this.pageIndex++;
            break;
        case "last":
            this.pageIndex = lastPage;
            break;
        default:
            this.pageIndex = parseInt(targetPage);
            break;
    }

    this.runSearch(this.pageIndex);
};

ExploreMore.prototype.toggleModal = function(e) {
    this.dom.$filterList.toggleClass(this.filterDisplayClass);
};

ExploreMore.prototype.updateFilters = function(e) {
    var filter = $(e.target);
    var label = filter.nextAll(this.labelClass),
        list = filter.data("filter-type") === "topic" ? this.filters.topics : this.filters.categories;

    if (filter.prop("checked")) {
        list.push({
            name: label.text(),
            value: filter.val()
        });

        this.dom.$appliedFilterList.append(
            "<button data-filter-type='" + filter.data("filter-type") + 
            "' data-filter-key='" + filter.val() + 
            "'>" + label.text() + "<span class='fa fa-times'></span></button>"
        );
    } else {
        list.splice(
            list.map(function(item, i) {
                return item.value;
            }).indexOf(filter.val()),
            1
        );

        this.dom.$appliedFilterList.find("[data-filter-key='" + filter.val() + "']").remove();
    }

    if (window.matchMedia("(min-width: 1024px)").matches) {
        this.pageIndex = 1;
        this.runSearch(this.pageIndex);
    }
};

ExploreMore.prototype.clearFilters = function(e) {
    var node = $(e.target);

    switch(node.data("filter-key")) {
        case "topics": 
            console.log('entra topics', node.data("filter-key"))
            this.filters.topics = [];
            this.dom.$filters.filter(function () {
                return $(this).data("filter-type") === "topic";
            }).prop("checked", false);
            this.dom.$appliedFilterList.find('[data-filter-type=topic]').remove();
            break;
        case "categories": 
            console.log('entra categories', node.data("filter-key"))
            this.filters.categories = [];
            this.dom.$filters.filter(function () {
                return $(this).data("filter-type") === "category";
            }).prop("checked", false);
            this.dom.$appliedFilterList.find('[data-filter-type=category]').remove();
            break;
        case "*":
            console.log('entra *')
            this.filters.categories = [];
            this.filters.topics = [];
            this.dom.$filters.prop("checked", false);
            this.dom.$appliedFilterList.find(":not([data-filter-key='*'])").remove();
            break;
        default:
            this.dom.$filters.filter(function() {
                return $(this).attr("value") === node.data("filter-key");
            }).prop("checked", false).change();
            break;
    }

    this.runSearch(1);
};

ExploreMore.prototype.updateResults = function() {
    this.dom.$resultsWrapper.empty();
    
    var _this = this, resultsHTML = "";
    if (this.results.length) {
        this.results.forEach(function (item, i) {

            var tags = item.Topics && item.Topics.length ? "<p>" + item.Topics.join(", ") + "</p>" : "";
            tags += item.ContentTypes && item.ContentTypes.length ? "<p>" + item.ContentTypes.join(", ") + "</p>" : "";
            
            var temp = "<div class=" + _this.cardClasses.card + ">" +
                (item.Image ? "<div class='" + _this.cardClasses.image + "'><img src='" + item.Image.Src + "' alt='" + item.Image.Alt + "'/></div>" : "") +
                "<h4 class='" + _this.cardClasses.title + "'><a href='" + item.Url + "'>" + item.Headline + "</a></h4>" +
                "<div class='" + _this.cardClasses.tags + "'>" + tags + "</div>" +
                "<div class='" + _this.cardClasses.text + "'>" + item.Teaser + "</div></div>";

            resultsHTML += temp;
        });
    } else {
        resultsHTML = this.dom.$noResultsMessage.html();
    }
    
    this.dom.$resultsWrapper.append(resultsHTML);
    this.updateSearchInfo();
    this.updatePagination();
};

ExploreMore.prototype.updateSearchInfo = function() {
    this.dom.$searchInfo.empty();
    
    var spacer = ", ";

    var topics = this.filters.topics.length ? this.filters.topics.map(function (item) {
        return item.name;
    }).join(spacer) : "";
    
    var categories = this.filters.categories.length ? this.filters.categories.map(function (item) {
        return item.name;
    }).join(spacer) : "";

    var number = this.results.length < this.pageSize ? this.results.length : this.pageSize;

    var temp = "Showing <span class='" + this.noteClass + "'>" + number + " of " + this.resultCount + " results</span>" + 
                (this.keyword ? "for<span class='" + this.noteClass + "'>" + this.keyword + "</span>" : "") + 
                (topics || categories ? "in<span class='" + this.noteClass + "'>" + 
                    topics + 
                    (categories && topics ? spacer : "") +
                    categories + 
                "</span>" : "");

    this.dom.$searchInfo.append(temp);
};

ExploreMore.prototype.updatePagination = function() {
    this.dom.$pagination.find("li:not(." + this.arrowClass + ")").remove();
    this.dom.$pagination.find("button").removeAttr("disabled");

    var pagecount = Math.ceil(this.resultCount / this.pageSize),
        pageLimit = pagecount - 4,
        prevArrow = this.dom.$pagination.find(".navigate--prev"),
        nextArrow = this.dom.$pagination.find(".navigate--next"),
        pages = '';

    if (pagecount > 1) {
        this.dom.$pagination.show();
        var i = 0, page = 1;

        while(page <= pagecount && i < 6) {
            pages += "<li class='" + (this.pageIndex === page ? "active'>" : "'>") + 
            "<button data-page-key='" + page + "'>" + page + "</button></li>";

            if(pagecount > 6) {
                if(this.pageIndex >= pageLimit && page < pageLimit) {
                    pages += "<li><span>...</span></li>";
                    page = pageLimit;
                } else {
                    page++;
                }

                if(this.pageIndex > 5 && this.pageIndex < pageLimit && page < this.pageIndex - 1) {
                    pages += "<li><span>...</span></li>";
                    page = this.pageIndex - 1;
                }

                if(i===4 && page < pagecount) {
                    pages += "<li><span>...</span></li>";
                    page = pagecount;
                }
            } else {
                page++;
            }

            i++;
        }

        $(pages).insertAfter(prevArrow);
    } else {
        this.dom.$pagination.hide();
    }
    
    var activeItem = this.dom.$pagination.find(".active");
    
    if (this.pageIndex === 1) {
        prevArrow.find('button').attr("disabled", true);
        prevArrow.prev().find('button').attr("disabled", true);
    }
    
    if (this.pageIndex === pagecount) {
        nextArrow.find('button').attr("disabled", true);
        nextArrow.next().find('button').attr("disabled", true);
    }
};

$('.wp-explore-more').each(function(i, el) {
    var item = new ExploreMore({
        element: $(el),
        form: ".wp-explore-more__search",
        field: ".wp-explore-more__search-field",
        noResultsMessage: "#explore-more-no-results",
        modalTrigger: ".wp-explore-more__filter-button, .wp-explore-more__filter-modal-button, .wp-explore-more__filter-hide",
        searchTriggers: ".wp-explore-more__filter-modal-button",
        filterList: ".wp-explore-more__filter-list",
        filters: ".wp-explore-more__card-input-field input[type=checkbox]",
        labelClass: ".wp-explore-more__card-input-field-checkbox-label",
        filterDisplayClass: "active",
        appliedFilterList: ".wp-explore-more__applied-filter-list",
        appliedFilters: ".wp-explore-more__applied-filter-list, .wp-explore-more__card-header",
        searchInfo: ".wp-explore-more__search-info",
        noteClass: "wp-explore-more__search-note",
        cardClasses: {
            card: "wp-explore-more__result-card",
            image: "wp-explore-more__result-image",
            title: "wp-explore-more__result-title",
            tags: "wp-explore-more__result-tags",
            text: "wp-explore-more__result-text"
        },
        pagination: ".wp-explore-more__page-list",
        arrowClass: "navigate",
        resultsWrapper: ".wp-explore-more__results-wrapper"
    });

    item.runSearch(1);
});
